import React, {Component} from "react"
import {Button, Container, Header, Icon, Loader, Segment, Table} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, interpolateString, parseMultilineString,} from "../utils/localization";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, getPrevNextStoryFromName, getStepProps, isAnsel} from "../utils/common";
import {setPrevRoute} from "../actions/appHeaderActions";
import Footer from "./footer";
import Steps from "./steps/steps";
import {CustomDivider, CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        lang: user.lang,
        initialData, user, benAdmin,
        ...ownProps
    }
};

class Helps3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props, initialData.distributionChannel);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    render() {
        const {stepProps} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(this.props.lang);
        const strings = localization.brellaHelp;
        const name = "Serena"
        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                    <div className="arrowsContainer">
                        <div className="arrowsCenterWrapper">
                            <div>
                                <Button circular icon className={'storyNavigation'}
                                        onClick={() => this.props.history.replace(getPrevNextStoryFromName(name).prev)}>
                                    <Icon name={'angle left'} size={'big'}/>
                                </Button>
                            </div>
                            <div>
                                <Button circular icon className={'storyNavigation'}
                                        onClick={() => this.props.history.replace(getPrevNextStoryFromName(name).next)}>
                                    <Icon name={'angle right'} size={'big'}/>
                                </Button>
                            </div>
                        </div>
                    </div>
                    <CustomGrid container stackable className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`}>
                        <CustomGrid.Row>
                            <CustomGrid.Column width={12}>
                                <Header as='h2' floated={"left"}>{interpolateString(strings.title, [name])}</Header>
                                <div style={{clear: 'both'}}/>
                                <p>{parseMultilineString(strings.subtitle)}</p>
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                        <CustomGrid.Row>
                            <CustomGrid.Column width={4}>
                                <Segment padded>
                                    <S3Image {...IMAGE.SERENA}/>
                                    <Header as='h4' textAlign="center">{strings.s3.serena}</Header>
                                    <p>{strings.s3.description}</p>
                                    <CustomDivider hidden/>
                                    <p className="primaryBoldColor">{interpolateString(strings.coverage, [name])}</p>
                                    <div>
                                        <div><span className="secondaryHeaderColor"><b>{strings.moderate}:</b></span> $700</div>
                                        <div><span className="secondaryHeaderColor"><b>{strings.severe}:</b></span> $2,000</div>
                                        <div><span className="secondaryHeaderColor"><b>{strings.catastrophic}:</b></span> $7,500
                                        </div>
                                    </div>
                                </Segment>
                            </CustomGrid.Column>
                            <CustomGrid.Column width={8} style={{padding: '0px'}}>
                                <Segment padded>
                                    <Header as='h4'>{interpolateString(strings.story, [name])}</Header>
                                    <CustomGrid>
                                        <CustomGrid.Row verticalAlign="middle">
                                            <CustomGrid.Column width={3} className={'noHorizontalPadding'}>
                                                <S3Image {...IMAGE.TORSO_CHEST}/>
                                            </CustomGrid.Column>
                                            <CustomGrid.Column width={9}>
                                                <div className="primaryBoldColor">{strings.s3.injury1Title}</div>
                                                <div>{strings.s3.injury1Desc}</div>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>
                                        <CustomGrid.Row verticalAlign="middle">
                                            <CustomGrid.Column width={3}>
                                                <S3Image {...IMAGE.WALLET_CASH}/>
                                            </CustomGrid.Column>
                                            <CustomGrid.Column width={9}>
                                                <div className="primaryBoldColor">{strings.s3.injury2Title}</div>
                                                <p>{strings.s3.injury2Desc}</p>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>
                                        <CustomGrid.Row verticalAlign="middle">
                                            <CustomGrid.Column width={3} className={'noHorizontalPadding'}>
                                                <S3Image {...IMAGE.CAR}/>
                                            </CustomGrid.Column>
                                            <CustomGrid.Column width={9}>
                                                <div className="primaryBoldColor">{strings.s3.injury3Title}</div>
                                                <p>{strings.s3.injury3Desc}</p>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>
                                    </CustomGrid>

                                    <CustomDivider medium hidden/>

                                    <Header as="h4">{interpolateString(strings.paymentsTitle, [name])}</Header>
                                    <Table basic='very' celled className={'howItHelpsTable'}>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell>{strings.s3.payout1}</Table.Cell>
                                                <Table.Cell collapsing textAlign="right">$7,500</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>{strings.s3.payout2}</Table.Cell>
                                                <Table.Cell collapsing textAlign="right">$7,500</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                        <Table.Footer fullWidth>
                                            <Table.Row>
                                                <Table.HeaderCell textAlign="right">
                                                    {interpolateString(strings.brellaCash, [name])}
                                                </Table.HeaderCell>
                                                <Table.HeaderCell collapsing textAlign="right"
                                                                  style={{borderLeft: 'none'}}>
                                                    <span><p><b>+ $15,000</b></p></span>
                                                </Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Footer>
                                    </Table>
                                    <CustomDivider hidden/>
                                </Segment>
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={strings.nextButton}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Helps3));
